import _ from 'lodash';
import localStore from './localStore';
import { LoginDTO, ModuleBaseUrl } from './models/login';
import {UserPage} from '../components/common/model';
import { AppConstants } from '@/shared/appConstants';

class AuthService {
    getJwtUser() {
      return localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_USER);
    }
  
    setJwtUser(login:LoginDTO) {
      localStore.setItem(AppConstants.LOCAL_STORAGE_KEY_USER, login);
    }
  
    removeJwtUser() {
      localStore.removeItem(AppConstants.LOCAL_STORAGE_KEY_USER);
    }

    getToken(){
      const user = localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_USER);
      if(user) return user.token;
      return undefined;
    }

    setToken(token:string){
      const user = localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_USER);
      if(user){
        user.token = token;
        this.setJwtUser(user);
      }
    }

    getUserEmail(){
      const user = localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_USER);
      if(user) return user.email;
      return undefined;
    }

    getFullName(){
      const user = localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_USER);
      if(user) return user.name;
      return undefined;
    }

    setPages(pages:UserPage[]){
      if(localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_PAGES)){
        localStore.removeItem(AppConstants.LOCAL_STORAGE_KEY_PAGES);
      }
      localStore.setItem(AppConstants.LOCAL_STORAGE_KEY_PAGES, pages);
    }

    getPages():UserPage[]{
      return localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_PAGES);
    }

    getModules(){
      const users = {...localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_USER)};
      if(users) return users.modules;
      return undefined;
    }

    getModulesBaseUrl(){
      const users = {...localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_USER)};
      if(users) return users.moduleBaseUrl;
      return undefined;
    }

    isHost(){
      const users = {...localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_USER)};
      if(users) return users.isHost;
      return false;
    }

    getOrganizationName(){
      const users = {...localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_USER)};
      if(users) return users.organizationName;
      return undefined;
    }

    getSubscriptionId(){
      const users = {...localStore.getItem(AppConstants.LOCAL_STORAGE_KEY_USER)};
      if(users) return users.subscriptionId;
      return undefined;
    }

    isAuthorized(){
      return !this.isExpired(this.getToken());
    }

    isExpired(token:string | undefined | null) {
      if(!token) return true;

      const base64Url = token.split(".")[1];
      const base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
      const jsonPayload = decodeURIComponent(
        atob(base64)
          .split("")
          .map(function (c) {
            return "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2);
          })
          .join("")
      );
    
      const { exp } = JSON.parse(jsonPayload);
      const expired = Date.now() >= exp * 1000;

      return expired;
    }
  }
  
  export default new AuthService();